<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.trigger' : 'misc.edition.trigger') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="triggerForm" *ngIf="triggerForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="triggerForm.get('name')"></app-validation-errors>
      </div>

      <div [hidden]="mode !== 'create'" class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            #tenantSelector
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            (onChange)="onTenantChange($event)"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            formControlName="tenant"
          ></p-dropdown>
        </div>
      </div>

      <div [hidden]="mode !== 'create'" class="col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="organization">{{'model.organization' | transloco}} </label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            #organizationSelector
            [placeholder]="'select.organization' | transloco"
            [options]="organizations"
            [filter]="true"
            [showClear]="true"
            (onClear)="onClearOrganization()"
            (onChange)="onOrganizationChange($event)"
            styleClass="w-full"
            id="organization"
            optionLabel="name"
            formControlName="organization"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.ruleType' | transloco}}</label>
          <i class="pi pi-question-circle ml-2 cursor-pointer" [pTooltip]="'forms.tooltips.triggers' | transloco" tooltipPosition="top"></i>
        </div>
        <div class="col-12 p-3">
          <p-radioButton
            [label]="'common.system' | transloco"
            class="mr-3"
            name="ruleType"
            value="SYSTEM"
            formControlName="ruleType"
          ></p-radioButton>
          <p-radioButton
            [label]="'common.user' | transloco"
            name="ruleType"
            value="USER"
            formControlName="ruleType"
          ></p-radioButton>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.category' | transloco}}</label>
          <i class="pi pi-question-circle ml-2 cursor-pointer" [pTooltip]="'forms.tooltips.triggers-category' | transloco" tooltipPosition="top"></i>
        </div>
        <div class="col-12 p-3">
          <p-radioButton
            [label]="'model.triggerCategories.alarm' | transloco"
            class="mr-3"
            name="category"
            value="ALARM"
            formControlName="category"
          ></p-radioButton>
          <p-radioButton
            [label]="'model.triggerCategories.warning' | transloco"
            name="category"
            value="WARNING"
            formControlName="category"
          ></p-radioButton>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.disabledRepeatedEvents' | transloco}}</label>
          <i class="pi pi-question-circle ml-2 cursor-pointer" [pTooltip]="'forms.tooltips.triggers-disabledRepeatedEvents' | transloco" tooltipPosition="top"></i>
        </div>
        <div class="col-12 p-3">
          <p-radioButton
            [label]="'common.yes' | transloco"
            class="mr-3"
            name="disabledRepeatedEvents"
            [value]="true"
            formControlName="disabledRepeatedEvents"
          ></p-radioButton>
          <p-radioButton
            [label]="'common.no' | transloco"
            name="disabledRepeatedEvents"
            [value]="false"
            formControlName="disabledRepeatedEvents"
          ></p-radioButton>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.entityType' | transloco}}</label>
        </div>
        <div class="col-12 p-3">
          <p-radioButton
            [label]="'model.device' | transloco"
            (ngModelChange)="entityTypeChanged($event)"
            class="mr-3"
            name="entityType"
            value="DEVICE"
            formControlName="entityType"
          ></p-radioButton>
          <p-radioButton
            [label]="'model.asset' | transloco"
            (ngModelChange)="entityTypeChanged($event)"
            name="entityType"
            value="ASSET"
            formControlName="entityType"
          ></p-radioButton>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4" *ngIf="triggerForm.get('entityType').value === 'DEVICE'">
        <div class="form-field col-12">
          <label for="device">{{'misc.applyToMeasurement' | transloco}}</label>
        </div>
        <div class="col-12">
          <app-device-measurements-selector
            #deviceMeasurementsSelector
            [entityUuid] = "entityUuid"
            [(visible)]="displayDeviceMeasurementSelector"
            [(selection)]="deviceMeasurementSelection"
            [tenant]="tenantSelector.value"
            [organization]="organizationSelector.value"
            selectionMode="single"
          ></app-device-measurements-selector>
          <button
            *ngIf="!deviceMeasurementSelection"
            [disabled]="!tenantSelector.value"
            [label]="'select.deviceMeasurement' | transloco"
            (click)="displayDeviceMeasurementSelector = true"
            pButton
            class="w-full"
          ></button>
          <div class="p-inputgroup" *ngIf="deviceMeasurementSelection">
            <input
              id="device"
              [value]="deviceMeasurementSelection.name + ' (' + deviceMeasurementSelection.device.serialNumber + ')'"
              [disabled]="mode === 'edit'"
              [class.cursor-pointer]="mode === 'create'"
              (click)="displayDeviceMeasurementSelector = true"
              readonly
              pInputText
              style="color: var(--text-color-secondary);"
              type="text"
            >
            <button
              [disabled]="!tenantSelector.value || mode === 'edit'"
              (click)="displayDeviceMeasurementSelector = true"
              pButton
              icon="pi pi-pencil"
            ></button>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4" *ngIf="triggerForm.get('entityType').value === 'ASSET'">
        <div class="form-field col-12">
          <label for="asset">{{'misc.applyToMeasurement' | transloco}}</label>
        </div>
        <div class="col-12">
          <app-asset-measurements-selector
            #assetMeasurementsSelector
            [(visible)]="displayAssetMeasurementSelector"
            [(selection)]="assetMeasurementSelection"
            [tenant]="tenantSelector.value"
            [organization]="organizationSelector.value"
            selectionMode="single"
          ></app-asset-measurements-selector>
          <button
            *ngIf="!assetMeasurementSelection"
            [disabled]="!tenantSelector.value"
            [label]="'select.assetMeasurement' | transloco"
            (click)="displayAssetMeasurementSelector = true"
            pButton
            class="w-full"
          ></button>
          <div class="p-inputgroup" *ngIf="assetMeasurementSelection">
            <input
              id="asset"
              [value]="assetMeasurementSelection.name + ' (' + assetMeasurementSelection.asset.alias + ')'"
              [disabled]="mode === 'edit'"
              [class.cursor-pointer]="mode === 'create'"
              (click)="displayAssetMeasurementSelector = true"
              readonly
              pInputText
              style="color: var(--text-color-secondary);"
              type="text"
            >
            <button
              [disabled]="!tenantSelector.value || mode === 'edit'"
              (click)="displayAssetMeasurementSelector = true"
              pButton
              icon="pi pi-pencil"
            ></button>
          </div>
        </div>
      </div>

    </div>
    <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="type">{{'attribute.type' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.type' | transloco"
            [options]="types"
            [filter]="false"
            [autoDisplayFirst]="false"
            (onChange)="onTypeChange($event)"
            styleClass="w-full"
            id="type"
            formControlName="type"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="expression">{{'attribute.value' | transloco}}</label>
        </div>
        <div class="col-12" *ngIf="triggerForm.get('type').value !== 'BYTE_MASK'">
          <input pInputText id="expression" type="text" formControlName="expression" class="w-full">
        </div>
        <div class="col-12" *ngIf="triggerForm.get('type').value === 'BYTE_MASK'">
          <app-byte-input formControlName="expression"></app-byte-input>
        </div>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="entityUuid !== undefined ? ['/devices', entityUuid.uuid, 'details'] : '/alarms/triggers'"
        pButton
        class="p-button-danger"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="triggerForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!triggerForm.valid || (deviceMeasurementSelection === undefined && assetMeasurementSelection === undefined)"
        [loading]="persistingChanges"
        (onClick)="persistTriggerData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
